<template>
	<div class="white" style="width: 100%; max-width: 1200px; margin-bottom: 0px; margin-top: 10px;">
		<h2 class="py-0 font-weight-semibold point7 text-xs-center">Connect With Us</h2>
		<div style="display: flex; flex-direction: row; justify-content: space-around; align-items: center; height: 200px; width: 100%; margin-top: 10px;">
            <p class="point6 mx-5 text-xs-center" style="width: 50%">
                Come join us at our Monthly Group Support Meetings and connect with others with ME/CFS and their whānau
            </p>
		    <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; width: 50%">
                <router-link to="/about/meetings">
                    <div class="row secondary button" style="display: flex;">
                        <p class="text-xs-center point55 whiteText font-weight-bold buttonText">MEETING &nbsp;DETAILS</p>
                    </div>
                </router-link>
		    </div>
		</div>
		<hr style="color: #BBB; margin-bottom: 20px;">
	</div>
</template>

<style>
.button {
	height: 6.0vh !important; width: 23vh !important; justify-content: center; align-items: center;
}
.buttonText {
	margin-top: auto; margin-bottom: auto; text-decoration: none; line-height: 90% !important;
}
</style>


<script>
export default {
	name: "MonthlyMeeting"
}
</script>